import React from "react";
import { useDropzone, FileWithPath, Accept } from "react-dropzone";

import "./DropBox.styles.css";

interface IDropBox {
  accept: Accept;
  onDrop: (files: FileWithPath[]) => void;
  allowedFileTypes?: string;
  className?: string;
}

const maxSize = 20 * 1024 * 1024;

const DropBox = ({
  accept,
  onDrop,
  className = "",
  allowedFileTypes = ".pdf",
}: IDropBox) => {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    accept,
    onDrop,
    maxSize: maxSize,
  });

  return (
    <div {...getRootProps({ className: `dropzone ${className}` })}>
      <input className="input-zone" {...getInputProps()} />
      <div className="text-center">
        {isDragActive ? (
          <p className="dropzone-content">Release to drop the files here</p>
        ) : (
          <>
            <p className="dropzone-content mb-1">
              Drag and drop some files here, or click to select files
            </p>
            <p>
              Allowed File Fomats {allowedFileTypes} / Size: less than 20 MB
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default DropBox;
